// Generated by ReScript, PLEASE EDIT WITH CARE

import * as HomeContent from "./HomeContent.re.mjs";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ChooseMediumSection from "./ChooseMediumSection.re.mjs";
import * as RescriptRelay_Fragment from "rescript-relay/src/RescriptRelay_Fragment.re.mjs";
import * as RescriptRelay_TestFragmentRef from "rescript-relay/src/RescriptRelay_TestFragmentRef.re.mjs";
import * as HomeFeaturedProducts_query_graphql from "../../../__generated__/HomeFeaturedProducts_query_graphql.re.mjs";

import { t } from '@lingui/macro'
;

let convertFragment = HomeFeaturedProducts_query_graphql.Internal.convertFragment;

function fromData(data) {
  return RescriptRelay_TestFragmentRef.make("HomeFeaturedProducts_query", data);
}

let Test = {
  fromData: fromData
};

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, HomeFeaturedProducts_query_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(HomeFeaturedProducts_query_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, HomeFeaturedProducts_query_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(HomeFeaturedProducts_query_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  Test: Test,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function toSample(item) {
  let match = item.url;
  let match$1 = item.sku;
  if (match === undefined) {
    return;
  }
  if (match$1 === undefined) {
    return;
  }
  let medium = HomeContent.mediumLabel(match$1).toLowerCase();
  return {
    id: item.id,
    src: match,
    alt: t`Custom ${medium} from a customer photo`,
    link: HomeContent.orderLink(match$1, item.id)
  };
}

function entry(sku, items) {
  return {
    sku: sku,
    samples: Stdlib_Array.filterMap(items, toSample)
  };
}

function HomeFeaturedProducts(props) {
  let data = RescriptRelay_Fragment.useFragment(HomeFeaturedProducts_query_graphql.node, convertFragment, props.query);
  let samples = [
    entry("custphotoreal", data.custphotoreal.map(x => ({
      id: x.id,
      url: x.url,
      sku: x.sku
    }))),
    entry("custwatercolor", data.custwatercolor.map(x => ({
      id: x.id,
      url: x.url,
      sku: x.sku
    }))),
    entry("custcharcoal", data.custcharcoal.map(x => ({
      id: x.id,
      url: x.url,
      sku: x.sku
    }))),
    entry("custpencil", data.custpencil.map(x => ({
      id: x.id,
      url: x.url,
      sku: x.sku
    }))),
    entry("custcoloredpencil", data.custcoloredpencil.map(x => ({
      id: x.id,
      url: x.url,
      sku: x.sku
    })))
  ];
  return JsxRuntime.jsx(ChooseMediumSection.make, {
    samples: samples
  });
}

let make = HomeFeaturedProducts;

export {
  Fragment,
  toSample,
  entry,
  make,
}
/*  Not a pure module */
